module.exports = __webpack_public_path__ + "img/14.303e837e.jpg";